<div class="form-group carm-form-group" [formGroup]="group">
  <div
    class="flex-item"
    *ngIf="!inDisplayControlOnly && labelPlacement === 'above' && inLabel"
  >
    <label [class.required]="isRequired" [for]="inId">
      <span id="label-{{ inId }}" class="field-name">{{ inLabel }}</span
      ><span *ngIf="inMaxLength && showMaxLength">
        {{ 'form.maxlength' | translate: { max: inMaxLength } }}</span
      >
      <strong *ngIf="isRequired" class="required carm-required mrgn-lft-sm"
        >({{ 'form.required' | translate }})</strong
      >
      <ng-content></ng-content>
      <!-- use this ng-content to pass the popover buttons and icons -->
    </label>
  </div>
  <ng-template
    *ngIf="errorPlacement === 'top'"
    [ngTemplateOutlet]="errorContent"
  ></ng-template>
  <div class="left-label-input-container">
    <div
      class="left-label-container"
      *ngIf="!inDisplayControlOnly && labelPlacement === 'left' && inLabel"
    >
      <label [class.required]="isRequired" [for]="inId">
        <span id="label-{{ inId }}" class="field-name">{{ inLabel }}</span>
        <strong *ngIf="isRequired" class="required carm-required mrgn-lft-sm"
          >({{ 'form.required' | translate }})</strong
        >
      </label>
    </div>
    <div class="extra-input-info" [class.fit-to-size]="fitToSize">
      <div *ngIf="extraInputInfo" class="extra-input-info">
        {{ extraInputInfo }}
      </div>
      <div class="input-wrapper">
        <span class="preLabel" *ngIf="preLabel">{{ preLabel }}</span>
        <span
          class="currency currency-left"
          *ngIf="currency && localeId === 'en'">{{ currency }}</span>
        <input
          [attr.aria-labelledby]="
            !inDisplayControlOnly ? 'label-' + inId : null
          "
          [attr.aria-label]="inDisplayControlOnly ? inLabel : null"
          [formControlName]="controlName"
          [type]="type"
          class="form-control carm-input {{
            !inDisplayControlOnly ? 'test_' + inId : null
          }}
          {{ upperCase ? 'upper-case-only' : null}}"
          [ngClass]="inClass"
          [id]="inId"
          [name]="controlName"
          [size]="inSize"
          [ngStyle]="inStyle"
          placeholder="{{ inHint }}"
          mask="{{ inMask }}"
          [validation]="inMaskValidation"
          thousandSeparator="{{ inThousandSeparator }}"
          separatorLimit="{{ inSeparatorLimit }}"
          [dropSpecialCharacters]="inDropSpecialCharacters"
          [decimalMarker]="inDecimalMarker"
          [allowNegativeNumbers]="inAllowNegativeNumbers"
          (blur)="inputblur.emit()"
          (focus)="inputfocus.emit()"
          (onkeyup)="keyup.emit()"
          (keypress)="keypress.emit()"
          [maxlength]="inMaxLength"
          [minlength]="inMinLength"
          [readonly]="readonly === true"
          [attr.data-cy]="inDataCy || inId"
          autocomplete="new-password"
          [carm-alphanumeric-only]="alphanumericOnly"
        />
        <ng-content select="[postFix]"></ng-content>
        <span class="currency currency-right" *ngIf="currency && localeId === 'fr'">{{ currency }}</span>
        <ng-template
          *ngIf="errorPlacement === 'right'"
          [ngTemplateOutlet]="errorContent"
        ></ng-template>
      </div>
    </div>
  </div>

  <ng-template #errorContent>
    <label
      *ngIf="formControl.errors && formControl.touched && displayErrors"
      class="flex-item carm-error-label"
    >
      <ng-container [ngSwitch]="formControl.errors.code">
        <span
          *ngSwitchCase="'MAXIMUM'"
          class="label label-danger carm-label-error"
        >
          {{
            formControl
              | errorKey
              | translate: { max: formControl['max'] || inMaxLength }
          }}
        </span>
        <span
          *ngSwitchCase="'MINIMUM'"
          class="label label-danger carm-label-error"
        >
          {{
            formControl
              | errorKey
              | translate: { min: formControl['min'] || inMinLength }
          }}
        </span>
        <span *ngSwitchCase="'REQUIRED'"
          class="label label-danger carm-label-error">
          {{ formControl | errorKey | translate }}
        </span>
        <span *ngSwitchCase="'ALPHANUMERIC'"
          class="label label-danger carm-label-error">
          {{ formControl | errorKey | translate }}
        </span>
        <span *ngSwitchDefault class="label label-danger carm-label-error">
          {{ formControl | errorKey | translate }}
        </span>
      </ng-container>
    </label>
  </ng-template>
</div>
